export default "__VITE_ASSET__DB9MeRir__"